import { NextPage } from 'next';
import { GetStaticProps, GetStaticPaths } from 'next';
import useRedirectToFirstPage from '@/hooks/useRedirectToFirstPage';
import Series from '@/components/screens/series/Series';
import { SERIES_FOR_PAGE, PRERENDER_PAGES, API_URL, REVALIDATE_TIME } from '@/helpers/variables';
import { getPagesNumbersPaths } from '@/helpers/helpers';
import { ISeries } from '@/interfaces/series.interface';
import { IWidgetsSideBar } from '@/interfaces/widgets.interface';

interface ISeriesPageProps extends IWidgetsSideBar {
  series: ISeries;
}

const SeriesPages: NextPage<ISeriesPageProps> = ({ series, todayWidget, popularBooksWidget }) => {
  useRedirectToFirstPage('/serii-knig/');

  return <Series series={series} todayWidget={todayWidget} popularBooksWidget={popularBooksWidget} />;
};

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = getPagesNumbersPaths(PRERENDER_PAGES);
  return {
    paths,
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps = async (context) => {
  const { pageNumber } = context.params!;

  const [seriesRes] = await Promise.all([fetch(`${API_URL}series/?status=active&page=${pageNumber}&page_size=${SERIES_FOR_PAGE}`)]);
  const [series] = await Promise.all([seriesRes.json()]);

  const [todayWidgetRes, popularBooksWidgetRes] = await Promise.all([fetch(`${API_URL}main/today/`), fetch(`${API_URL}main-page/popular_books`)]);
  const [todayWidget, popularBooksWidget] = await Promise.all([todayWidgetRes.json(), popularBooksWidgetRes.json()]);

  return { props: { series, todayWidget, popularBooksWidget }, revalidate: REVALIDATE_TIME };
};

export default SeriesPages;
